import React, { useState } from "react";
import { Flex } from "rebass/styled-components";

import { LabelReadOnly } from "../../../../Components/Form/Label";
import { Button } from "../../../../Components/Button";
import { useIsDesktopApp } from "../../../../Hooks/useIsDesktopApp";
import { LinkedAccountsViewModel } from "../../ViewModel";
import { SharecodeLink } from "MVVM/Components/Sharecode/styledComponents";
import {
  DisabledButton,
  IconWrapper,
  SharecodeButton,
  StyledBody,
  StyledBox,
  StyledSteamIcon,
  UnlinkButton,
} from "../styledComponents";
import { useHistory } from "react-router-dom";
import { URLS } from "../../../../Utilities/Maps";
import { useUser } from "../../../../Hooks/useUser";
const STEAM_URL =
  "https://help.steampowered.com/en/wizard/HelpWithGameIssue/?appid=730&issueid=128";
const { REACT_APP_BASE_URL } = process.env;
const LinkSteam = ({ buttonText }: { buttonText: string }) => {
  const { unlinkAccount } = LinkedAccountsViewModel();
  const { allstarUser } = useUser();
  const { isDesktop } = useIsDesktopApp();
  const steamUsedForSignup = allstarUser.user?.steam?.usedForSignUp;
  const history = useHistory();
  const [linked, setLinked] = useState(!!allstarUser?.user?.steam?.active);

  const link = async () => {
    if (isDesktop) {
      window.parent.postMessage(
        {
          type: "openLink",
          link: `${REACT_APP_BASE_URL}${URLS.AUTH_ROUTES.STEAM}?flow=link&referrer=DESKTOP_APP`,
        },
        "*",
      );
      return;
    }
    history.push(
      `${URLS.AUTH_ROUTES.STEAM}?flow=link&referrer=CONNECTED_ACCOUNTS`,
    );
  };

  const unlink = async () => {
    await unlinkAccount({ variables: { accountType: "steam" } });
    setLinked(!linked);
  };

  return (
    <>
      <Flex pt={5} alignItems="center">
        <IconWrapper>
          <StyledSteamIcon />
        </IconWrapper>
        {linked ? (
          <Flex width="100%" style={{ gap: "8px" }} alignItems={"center"}>
            <LabelReadOnly
              label={"Steam"}
              text={allstarUser.user?.steam?.personaname}
            />
            {steamUsedForSignup ? (
              <DisabledButton
                size="small"
                flex={true}
                maxWidth={2}
                classification="secondary"
                title="You cannot unlink your primary login account."
                disabled
              >
                Unlink
              </DisabledButton>
            ) : (
              <UnlinkButton
                size="small"
                flex={true}
                maxWidth={2}
                classification="secondary"
                onClick={() => unlink()}
              >
                Unlink
              </UnlinkButton>
            )}
          </Flex>
        ) : (
          <Button
            size="small"
            flex={true}
            maxWidth={2}
            width="100%"
            classification="secondary"
            target="_blank"
            onClick={() => link()}
          >
            {buttonText}
          </Button>
        )}
      </Flex>
      {linked && (
        <StyledBox mt={3}>
          <StyledBody>
            {allstarUser.user.hasSharecodes ? (
              "Update your CS2 authentication code and share code."
            ) : (
              <>
                Get your latest matches with Steam Share Codes.
                <SharecodeLink
                  style={{ display: "block" }}
                  marginLeft={2}
                  onClick={() => window.open(STEAM_URL, "_blank")}
                >
                  Here is how to find and copy them.
                </SharecodeLink>
              </>
            )}
            <SharecodeButton
              size="small"
              flex={true}
              maxWidth={2}
              marginTop={12}
              onClick={() => {
                if (isDesktop) {
                  window.parent.postMessage(
                    {
                      type: "openLink",
                      link: "https://allstar.gg/add-share-codes",
                    },
                    "*",
                  );
                } else {
                  history.push("/add-share-codes");
                }
              }}
            >
              {allstarUser.user.hasSharecodes
                ? "Update Share Code"
                : "Add Share Code"}
            </SharecodeButton>
          </StyledBody>
        </StyledBox>
      )}
    </>
  );
};

export { LinkSteam };
